import User from './User'

export default class Client
{
    constructor() {
      this.legal_name = ''
      this.trading_name = ''
      this.user = new User
      this.abilities = []
    }
}